import { render, staticRenderFns } from "./MarginAllocationDrawer.vue?vue&type=template&id=312ac96a&scoped=true"
import script from "./MarginAllocationDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./MarginAllocationDrawer.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MarginAllocationDrawer.vue?vue&type=style&index=0&id=312ac96a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312ac96a",
  null
  
)

export default component.exports